import { type HTMLAttributes } from "vue";

import InspirationIcon from "~/assets/icons/home.svg?raw";
import ProfessionalIcon from "~/assets/icons/star.svg?raw";
import ArchitectIcon from "~/assets/icons/pencil-ruler.svg?raw";
import RelaxationIcon from "~/assets/icons/relax.svg?raw";
import HammerIcon from "~/assets/icons/hammer.svg?raw";
import BriefcaseIcon from "~/assets/icons/briefcase.svg?raw";

export const useGoogleMapsMarker = () => {
  const { getPaletteForPostType } = useTheme();

  const createMarkerContent = (
    options: {
      postType?: MaybeRef<PostType>;
      onClick?: HTMLAttributes["onClick"];
      badge?: MaybeRef<string>;
      small?: MaybeRef<boolean>;
    } = {}
  ): HTMLElement => {
    const postType = unref(options.postType);
    const onClick = unref(options.onClick);
    const badge = unref(options.badge);
    const small = unref(options.small);

    const el = document.createElement("button");

    el.addEventListener("click", (event) => {
      event.preventDefault();
      return onClick ? onClick(event) : void 0;
    });

    el.className = [
      "relative",
      small ? "w-8 h-8" : "w-10 h-10",
      small ? "rounded-s-lg rounded-b-lg" : "rounded-s-xl rounded-b-xl",
      "-translate-x-1/2 translate-y-full",
      "text-white",
      "flex items-center justify-center",
      "[&_svg]:w-6 [&_svg]:h-6",
      "cursor-pointer",
      "!pointer-events-auto",
      getPaletteForPostType(postType)?.bg || "bg-gray-500",
    ].join(" ");

    if (postType) {
      el.innerHTML =
        {
          [PostType.Inspiration]: InspirationIcon,
          [PostType.Professional]: ProfessionalIcon,
          [PostType.Architect]: ArchitectIcon,
          [PostType.Relaxation]: RelaxationIcon,
          [PostType.Contractor]: HammerIcon,
          [PostType.Project]: BriefcaseIcon,
        }[postType] || "";
    }

    if (badge) {
      const badgeElement = document.createElement("span");

      badgeElement.className = [
        "block absolute top-0 right-0",
        "h-6 min-w-6 px-1",
        "rounded-full",
        "text-base text-center font-semibold",
        "flex items-center justify-center",
        "bg-black text-white",
        "transform translate-x-1/2 -translate-y-1/2",
      ].join(" ");

      badgeElement.textContent = badge;

      el.appendChild(badgeElement);
    }

    return el;
  };

  return { createMarkerContent };
};
